import React from "react"
import { AnimatePresence, motion } from "motion/react"
import { createPortal } from "react-dom"
import "./DialogCustom.scss"

export interface DialogCustomProps {
    open: boolean
    width?: number | string
    title?: string
    showIcon?: boolean
    showClose?: boolean
    onCancel?: () => void
    children?: React.ReactNode
    icon?: any
    style?: React.CSSProperties
}

export function DialogCustom(props: DialogCustomProps) {
    const {
        open,
        width = "40vw",
        title = "",
        showIcon = true,
        showClose = true,
        onCancel,
        children,
        icon,
        style,
    } = props

    // 计算弹窗宽度
    const dialogWidth = typeof width === "number" ? `${Math.min(width, 100)}vw` : width

    // 居中定位（所有动画状态共享）
    const centerPosition = { x: "-50%", y: "-50%" }

    return createPortal(
        <AnimatePresence>
            {open && (
                <motion.div
                    className="dialog-custom"
                    style={{
                        width: dialogWidth,
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        zIndex: 2007,
                        ...style,
                    }}
                    initial={{ opacity: 0, scale: 0.3, ...centerPosition }}
                    animate={{ opacity: 1, scale: 1, ...centerPosition }}
                    exit={{ opacity: 0, scale: 0.3, ...centerPosition }}
                    transition={{ duration: 0.3 }}
                >
                    {/* 标题栏 */}
                    {(title || showIcon || showClose) && (
                        <div className="dialog-custom-title">
                            <div className="left">
                                {showIcon && (
                                    <div className="dialog-title-icon">{icon || "📣"}</div>
                                )}
                                <span>{title}</span>
                            </div>
                            <div className="right">
                                {showClose && (
                                    <div
                                        className="dialog-close-icon"
                                        onClick={onCancel}
                                        role="button"
                                        aria-label="关闭弹窗"
                                    >
                                        ✕
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* 内容区域 */}
                    <div className="dialog-custom-content">{children}</div>
                </motion.div>
            )}
        </AnimatePresence>,
        document.body,
    )
}

export default DialogCustom
